import * as ViewletSourceControl from './ViewletSourceControl.js'

// prettier-ignore
export const Commands = {
  '6532': ViewletSourceControl.acceptInput
}

export * from './ViewletSourceControl.js'
